import type { ReactNode, FormEventHandler } from 'react';
import type { FieldValues, UseFormReturn } from 'react-hook-form';

import { FormProvider } from 'react-hook-form';

type Props<T extends FieldValues> = {
  methods: UseFormReturn<T>;
  onSubmit?: FormEventHandler<HTMLFormElement>;
  children: ReactNode;
  className?: string;
};

/** `FormProvider` + `<form>` (remplace `Form` de Minimal). */
export const Form = <T extends FieldValues>({ methods, onSubmit, children, className }: Props<T>) => (
  <FormProvider {...methods}>
    <form autoComplete="off" className={className} noValidate onSubmit={onSubmit}>
      {children}
    </form>
  </FormProvider>
);
